/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Flex } from '@tonic-one/react';
import isEqual from 'lodash/isEqual';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormList, TitleLabel } from 'src/components/Common/FormComponent';
import { generalExport } from 'src/pages/Policy/utils/fns';

import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import { ExchangeOnlinePolicyItem } from '@Policy/utils/types';
import {
  ddaApprovedFileNameEntriesSelector,
  ddaApprovedSenderEmailEntriesSelector,
} from '@Policy/store/filters/virtualAnalyzer';
import ImportModal from '../../Components/ImportModal';
export const VaSenderList = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state from store
  const ddaApprovedSenderEmailEnabled = policySelector(
    (s) => s.tmDdafilters.ddaApprovedSenderEmailEnabled
  );
  const approvedSenderList = contextSelector(
    ddaApprovedSenderEmailEntriesSelector,
    isEqual
  );
  const approvedListMaxCount = contextSelector(
    (s) => s.config.approvedListMaxCount
  );
  // get action from store
  const setDdaState = contextSelector((s) => s.setDdaState);
  const addDdaApprovedSender = contextSelector((s) => s.addDdaApprovedSender);
  const removeDdaApprovedSender = contextSelector(
    (s) => s.removeDdaApprovedSender
  );
  const importDdaApprovedSender = contextSelector(
    (s) => s.importDdaApprovedSender
  );
  // local state
  // approved email list
  // status change
  const handleDdaApprovedSenderEmailEnabledChange = React.useCallback(() => {
    setDdaState({
      ddaApprovedSenderEmailEnabled: ddaApprovedSenderEmailEnabled ? 0 : 1,
    });
  }, [ddaApprovedSenderEmailEnabled]);
  // export email
  const handleApprovedEmailsExport = React.useCallback((entries: any) => {
    generalExport({
      entries: entries.map((entry: any) => entry.value),
      name: 'approved-email-list',
    });
  }, []);
  // import email
  const [
    isApprovedSenderImportModalVisible,
    setIsApprovedSenderImportModalVisible,
  ] = React.useState(false);
  const handleApprovedSenderImportModalClose = React.useCallback(() => {
    setIsApprovedSenderImportModalVisible(false);
  }, []);
  const handleApprovedSenderImportModalOpen = React.useCallback(() => {
    setIsApprovedSenderImportModalVisible(true);
  }, []);
  const handleApprovedSenderImport = React.useCallback((entries: any) => {
    console.log('import entries', entries);
    importDdaApprovedSender(entries as string[]);
    setIsApprovedSenderImportModalVisible(false);
  }, []);
  return (
    <div>
      <Box ml="1px" mt="34px">
        <Flex direction="column">
          <TitleLabel title={t('policy.title.senders')} />
          <FormList
            onAdd={addDdaApprovedSender}
            onDelete={removeDdaApprovedSender}
            onExport={handleApprovedEmailsExport}
            onImport={handleApprovedSenderImportModalOpen}
            list={approvedSenderList}
            limit={approvedListMaxCount}
            status={!!ddaApprovedSenderEmailEnabled}
            setStatus={handleDdaApprovedSenderEmailEnabledChange}
            label={t('policy.approvedSenderList.title')}
            description={t('policy.approvedSenderList.supportWildcardDesc')}
          />
        </Flex>
      </Box>
      <ImportModal
        isVisible={isApprovedSenderImportModalVisible}
        onClose={handleApprovedSenderImportModalClose}
        onImport={handleApprovedSenderImport}
      />
    </div>
  );
};
export const VaFileList = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state from store
  const ddaApprovedFileNameEnabled = policySelector(
    (s) => s.tmDdafilters.ddaApprovedFileNameEnabled
  );
  const approvedFileList = contextSelector(
    ddaApprovedFileNameEntriesSelector,
    isEqual
  );
  const approvedFileExtensionCount = contextSelector(
    (s) => s.config.approvedFileExtensionCount
  );
  // get action from store
  const setDdaState = contextSelector((s) => s.setDdaState);
  const addDdaApprovedFile = contextSelector((s) => s.addDdaApprovedFile);
  const removeDdaApprovedFile = contextSelector((s) => s.removeDdaApprovedFile);
  const importDdaApprovedFile = contextSelector((s) => s.importDdaApprovedFile);
  // local state
  // approved file list
  // status change
  const handleDdaApprovedFileNameEnabledChange = React.useCallback(() => {
    setDdaState({
      ddaApprovedFileNameEnabled: ddaApprovedFileNameEnabled ? 0 : 1,
    });
  }, [ddaApprovedFileNameEnabled]);
  // export file
  const handleApprovedFileExport = React.useCallback((entries: any) => {
    generalExport({
      entries: entries.map((entry: any) => entry.value),
      name: 'approved-file-list',
    });
  }, []);
  // import file
  const [
    isApprovedFileImportModalVisible,
    setIsApprovedFileImportModalVisible,
  ] = React.useState(false);
  const handleApprovedFileImportModalClose = React.useCallback(() => {
    setIsApprovedFileImportModalVisible(false);
  }, []);
  const handleApprovedFileImportModalOpen = React.useCallback(() => {
    setIsApprovedFileImportModalVisible(true);
  }, []);
  const handleApprovedFileImport = React.useCallback((entries: any) => {
    console.log('import entries', entries);
    importDdaApprovedFile(entries as string[]);
    setIsApprovedFileImportModalVisible(false);
  }, []);

  return (
    <div>
      <Box ml="1px" mt="34px">
        <Flex direction="column">
          <TitleLabel title={t('policy.approvedAndBlockedList.files')} />
          <FormList
            onAdd={addDdaApprovedFile}
            onDelete={removeDdaApprovedFile}
            onExport={handleApprovedFileExport}
            onImport={handleApprovedFileImportModalOpen}
            list={approvedFileList}
            limit={approvedFileExtensionCount}
            status={!!ddaApprovedFileNameEnabled}
            setStatus={handleDdaApprovedFileNameEnabledChange}
            placeholder={t('policy.placeholder.file')}
            label={t('policy.approvedAndBlockedList.filesList')}
            description={`(${t(
              'policy.approvedAndBlockedList.filesList.desc'
            )})`}
          />
        </Flex>
      </Box>
      <ImportModal
        isVisible={isApprovedFileImportModalVisible}
        onClose={handleApprovedFileImportModalClose}
        onImport={handleApprovedFileImport}
      />
    </div>
  );
};
function VaApproveBlockList({
  senderListShow = false,
  fileListShow = false,
}: {
  senderListShow: boolean;
  fileListShow: boolean;
}) {
  return (
    <>
      {senderListShow ? <VaSenderList /> : null}
      {fileListShow ? <VaFileList /> : null}
    </>
  );
}

export default React.memo(VaApproveBlockList);
